//css-------------------
import "@/css/home/article_content.scss";

//swiper
import(/* webpackPrefetch: true */ "swiper/css/pagination");


//components js-------------------
import(/* webpackPrefetch: true */ "@/js/share/components/_common_lazy");
import(/* webpackPrefetch: true */ "@/js/share/components/_font_family");
import(/* webpackPrefetch: true */ "@/js/share/components/_tracker");
import { init_imageloaded } from "@/js/share/components/_imageloader.js";
import { sponsor_swiper } from "@/js/share/components/_sponsor_swiper.js";
import { list_swiper } from "@/js/share/components/_list_swiper.js";
import { sidenav_toggle } from "@/js/share/components/_sidenav.js";


//npm lib  
import $ from "jquery";
import { createApp, baseData, baseWatch, baseMethods } from "@/js/share/_home_app";
import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit.js";

const app = createApp({
    data() {
        return {
            ...baseData(),
        };
    },
    watch: {
        ...baseWatch(this),
    },
    mounted() {
        const _this = this;
        this.fastlink_toggle();
        init_imageloaded(function () {
            sponsor_swiper();
            list_swiper();
            $('.tpl_content').find('img').each(function () {
                const _width = $(this).attr('width');
                if (!_width !== undefined) {
                    const _style = $(this).attr('style') ? $(this).attr('style') + ';' : '';
                    $(this).attr('style', _style + 'width:' + (_width / 16) + 'rem;');
                }
            });
        });
    },
    methods: {
        ...baseMethods,
        sidenav_toggle,
    },
}).mount("#app");
